import { mediaQueriesMixin } from '@/ghost-mixins';
import { helper } from '@/ghost-mixins';

export const ghostWriterRankingMixin = {
    name: 'GWRankingList',
    mixins: [mediaQueriesMixin, helper],
    methods: {
        getScore(provider) {
            let score = provider?.rating;
            if (!score) {
                return '0.0';
            }
            if (score.toString().length < 2) {
                score = score + '.0';
            }
            return score.toString();
        },
        parseIcons(provider) {
            let partnerIcons = [];
            let iconPath = 'img/icons/partner-icons/';
            let iconFileFormat = 'svg';

            for (const key in provider['icons']) {
                const set = provider['icons'][key];
                if (!set || set.length === 0) continue;
                const icons = set.split('*');

                for (const iconKey in icons) {
                    const icon = icons[iconKey];
                    if (icon.length === 0) continue;
                    partnerIcons.push({
                        url: `${iconPath}${icon}.${iconFileFormat}`,
                        name: icon,
                    });
                }
            }
            return partnerIcons;
        },
        getLogo(provider) {
            return this.resizeImage(provider['provider_logo'], 180, 120, 80);
        },
        gotoLink(partner) {
            const link = partner['clickout_url'];
            return this.attachTrackingParams(link);
        },
        gotoLinkByProviderIndex(index) {
            if (this.providers && this.providers[index]) {
                return this.gotoLink(this.providers[index]);
            }

            return '';
        },
    },
    computed: {
        topProvider() {
            if (this.providers.length > 0) return this.providers[0];
            return null;
        },
    },
    data() {
        return {
            mediaUrl: this.$globalConstants.imageUrl,
        };
    },
};
